export default "__VITE_ASSET__3499dc0f__"